import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'icon',
    (theme, [checked]) => `
    :lang(ar){
      transform: scaleX(-1);
    }
		color: ${theme.survey.control[checked ? 'active' : 'default']};
		transition: color 0.2s;
	`
  ]
]);
